import { deepDives } from "@/mocks/archive";

const cardIcons = [
  "ri-bar-chart-box-line",
  "ri-shield-check-line",
  "ri-question-answer-line",
  "ri-map-2-line",
  "ri-line-chart-line",
  "ri-database-2-line",
];

export default function DeepDive() {
  return (
    <section id="deep" className="bg-background-100 border-t border-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
              <i className="ri-focus-3-line" />
              专题盘点
            </p>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              标题优先 · 深度档案
            </h2>
          </div>
          <span className="hidden md:inline-flex items-center gap-1.5 text-xs text-foreground-500 whitespace-nowrap">
            <i className="ri-lightbulb-flash-line" />
            配图克制，正文更重考据
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {deepDives.map((d, i) => (
            <a
              key={d.id}
              href="#faq"
              className="group relative rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-300 hover:-translate-y-0.5 transition-all flex flex-col"
            >
              <span className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                <i className={cardIcons[i % cardIcons.length] + " text-xl"} />
              </span>
              <span className="inline-flex w-fit rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900 whitespace-nowrap">
                {d.tag}
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-900 group-hover:text-primary-700 transition-colors">
                {d.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1 line-clamp-3">
                {d.summary}
              </p>
              <span className="mt-5 inline-flex items-center gap-1.5 text-xs font-medium text-primary-700 whitespace-nowrap">
                <i className="ri-arrow-right-line" />
                {d.read}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}